import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  footer: {
    alignItems: 'flex-end',
    background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 2%, rgb(${theme.palette.black}) 27%)`,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    minHeight: '110px',
    padding: '1rem',
    position: 'fixed',
    transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeOut}`,
    width: '100%',
    zIndex: 99,
    [theme.breakpoints.up('sm')]: {
      minHeight: '150px',
    },
  },
  siteSharing: {
    display: 'flex',
    justifyContent: 'space-between',
    listStyleType: 'none',
    margin: 0,
    maxWidth: '160px',
    padding: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 'none',
    },
  },
  siteSharingItem: {
    height: '28px',
    width: '28px',
  },
  siteSharingText: {
    color: `rgb(${theme.palette.doveGray})`,
    fontFamily: theme.typography.secondary,
    fontSize: '0.875rem',
    letterSpacing: '0.06em',
    marginBottom: '0.75rem',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  siteSharingWrap: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}))

export default useStyles
